import { render, staticRenderFns } from "./TerminAbgesagt.vue?vue&type=template&id=56b6adfc"
import script from "./TerminAbgesagt.vue?vue&type=script&lang=js"
export * from "./TerminAbgesagt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports